import React from 'react'
import { JourneyNotificationCompTabState } from './types'

export type JourneyNotificationsComparisonContext = JourneyNotificationCompTabState & {
    onRefreshClick(ev: React.MouseEvent<HTMLElement>): Promise<void>
    onRefreshEnabledChange(enabled: boolean): void
    onCompareClick(): void
}

export const JourneyNotificationsComparisonContext = React.createContext<JourneyNotificationsComparisonContext>(
    {} as JourneyNotificationsComparisonContext,
)
